import {
  name as documentsIds,
  reducer as documentsIdsReducer,
} from '@/features/admin/documentsIds/reducer';
import {
  name as documentsSimStudioData,
  reducer as documentsSimStudioDataReducer,
} from '@/features/admin/documentsSimStudioData/reducer';
import { name as kbIds, reducer as kbIdsReducer } from '@/features/admin/kbIds/reducer';
import {
  name as reportsCount,
  reducer as reportsCountReducer,
} from '@/features/admin/reportsCount/reducer';
import {
  name as signUpAllowed,
  reducer as signUpAllowedReducer,
} from '@/features/admin/signUpAllowed/reducer';
import {
  name as signupNotificationEmails,
  reducer as signupNotificationEmailsReducer,
} from '@/features/admin/signupNotificationEmails/reducer';
import {
  name as usersManage,
  reducer as usersManageReducer,
} from '@/features/admin/userManage/reducer';
import { name as users, reducer as usersReducer } from '@/features/auth/reducer';
import {
  name as conopFinal,
  reducer as conopFinalReducer,
} from '@/features/generators/conopFinal/reducer';
import {
  name as conopPhase1,
  reducer as conopPhase1Reducer,
} from '@/features/generators/conopPhase1/reducer';
import { name as ira, reducer as iraReducer } from '@/features/generators/ira/reducer';
import { name as lops, reducer as lopsReducer } from '@/features/generators/lop/reducer';
import { name as paw, reducer as pawReducer } from '@/features/generators/paw/reducer';
import { name as ppag, reducer as ppagReducer } from '@/features/generators/ppag/reducer';
import { name as ptals, reducer as ptalsReducer } from '@/features/generators/ptal/reducer';
import { name as rtags, reducer as rtagsReducer } from '@/features/generators/rtag/reducer';
import { name as scws, reducer as scwsReducer } from '@/features/generators/scw/reducer';
import { name as sdw, reducer as sdwReducer } from '@/features/generators/sdw/reducer';
import { name as sem, reducer as semReducer } from '@/features/generators/sem/reducer';
import { name as spos, reducer as sposReducer } from '@/features/generators/spo/reducer';
import { name as taaws, reducer as taawsReducer } from '@/features/generators/taaw/reducer';
import { name as chats, reducer as chatsReducer } from '@/features/results/reducer';
import { name as trends, reducer as trendsReducer } from '@/features/trends/reducer';
import { combineReducers } from '@reduxjs/toolkit';

export const reducer = combineReducers({
  [chats]: chatsReducer,
  [users]: usersReducer,
  [conopFinal]: conopFinalReducer,
  [conopPhase1]: conopPhase1Reducer,
  [ira]: iraReducer,
  [spos]: sposReducer,
  [paw]: pawReducer,
  [ppag]: ppagReducer,
  [ptals]: ptalsReducer,
  [rtags]: rtagsReducer,
  [taaws]: taawsReducer,
  [trends]: trendsReducer,
  [documentsIds]: documentsIdsReducer,
  [documentsSimStudioData]: documentsSimStudioDataReducer,
  [reportsCount]: reportsCountReducer,
  [signUpAllowed]: signUpAllowedReducer,
  [signupNotificationEmails]: signupNotificationEmailsReducer,
  [kbIds]: kbIdsReducer,
  [usersManage]: usersManageReducer,
  [lops]: lopsReducer,
  [scws]: scwsReducer,
  [sdw]: sdwReducer,
  [sem]: semReducer,
});

export type State = ReturnType<typeof reducer>;

declare module '@/reducers/types' {
  interface State extends ReturnType<typeof reducer> {}
}
